import { cut } from "@-/com.npmjs.react-native-jieba";
import { hasHanScript } from "@-/dev.improve.haniverse.lib.unicode";

import type { KnownDatabaseWords } from "#chinese-words-trie";

function segmentHanWithKnownWords(text: string, knownWords: KnownDatabaseWords): string[] {
  const segments: string[] = [];
  let index = 0;
  while (index < text.length) {
    const char = text[index] ?? "";
    if (!hasHanScript(char)) {
      segments.push(char);
      index += 1;
      continue;
    }
    const match = knownWords.longestWordAt(text, index);
    if (match !== undefined) {
      segments.push(match);
      index += match.length;
    } else {
      segments.push(char);
      index += 1;
    }
  }
  return segments;
}

/**
 * Segment a sentence with jieba, then ensure each Han token is a word row in the static database.
 * Unknown jieba segments are re-split with longest-match against `knownWords` — the caller supplies
 * the vocabulary (queried per-sentence from the static `word` table), rather than this module bundling
 * the full word list. See `useSentenceWordsQueryOptions`.
 */
export function getSentenceWords(sentence: string, knownWords: KnownDatabaseWords): string[] {
  if (sentence.length === 0) {
    return [];
  }
  const segments = cut(sentence);
  const words: string[] = [];
  for (const segment of segments) {
    if (!hasHanScript(segment) || knownWords.has(segment)) {
      words.push(segment);
      continue;
    }
    words.push(...segmentHanWithKnownWords(segment, knownWords));
  }
  return words;
}
